export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "TeamMasterImportWorker.f4286503312b17dd3548.worker.js");
}
